import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function NumericalInput(props) {
  const [value, setValue] = useState();
  const [key, setKey] = useState(props.label + props.defaultValue);
  const { t } = useTranslation();

  const validateNumericalInput = (value, low, high, no_error) => {
    var val = Number(value);
    if (
      isNaN(val) ||
      (!isNaN(low) && val < low) ||
      (!isNaN(high) && val > high)
    ) {
      var err =
        "Error: " +
        props.label +
        ". " +
        t("numericalInput.invalidValue", "Invalid value") +
        " " +
        value;
      if (!isNaN(low) && isNaN(high)) {
        err =
          err +
          ". " +
          t("numericalInput.allowedValues", "Allowed values") +
          " " +
          low +
          " -->";
      }
      if (!isNaN(low) && !isNaN(high)) {
        err =
          err +
          ". " +
          t("numericalInput.allowedValues", "Allowed Values") +
          " " +
          low +
          " - " +
          high;
      }
      if (!no_error) {
        throw Error(err);
      }
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (
      validateNumericalInput(
        props.defaultValue,
        props.inputProps?.min,
        props.inputProps?.max,
        true,
      )
    ) {
      setValue(props.defaultValue);
      return;
    }
    setValue();
  }, [props.defaultValue]);

  return (
    <TextField
      type="number"
      InputLabelProps={{ shrink: !isNaN(value) || undefined }}
      value={value}
      {...props}
      key={key}
      onChange={(e) => {
        try {
          validateNumericalInput(
            e.target.value,
            props.inputProps?.min,
            props.inputProps?.max,
          );
        } catch (error) {
          alert(error.message);
          setValue();
          setKey(Date.now());
          return;
        }
        setValue(e.target.value);
        props.onChange(e);
      }}
    />
  );
}
